import { Item } from '../../core';
import { Status } from '../model/status.model';

export function filterByStatus(
    statuses: Status[] | null,
    items: Item[],
    retainUnreadAsUnread?: number[],
): Item[] {
    if (statuses == null || statuses.length === 0) {
        return [...items];
    }

    return items.filter((e) => {
        const retainAsUnread = retainUnreadAsUnread?.includes(
            e.eventCentreItemId,
        );
        return (
            (e.read && statuses.includes(Status.READ) && !e.deleted) ||
            (((!e.read && statuses.includes(Status.UNREAD)) ||
                retainAsUnread) &&
                !e.deleted) ||
            (e.deleted && statuses.includes(Status.DELETED))
        );
    });
}
